import React from "react";
import RecentNotifications from "../../../views/internal/shared/inapp-notifications/recentNotifications";
import "./Actions.scss";
import UserProfileAvatar from "./UserProfileAvatar";
const Actions = () => (React.createElement("div", { className: "actions" },
    React.createElement(RecentNotifications, null),
    React.createElement(UserProfileAvatar, null)));
export default Actions;
